export default {
	ENUM: {
		Month: {
			JANUARY: 'Janeiro',
			FEBRUARY: 'Fevereiro',
			MARCH: 'Março',
			APRIL: 'Abril',
			MAY: 'Maio',
			JUNE: 'Junho',
			JULY: 'Julho',
			AUGUST: 'Agosto',
			SEPTEMBER: 'Setembro',
			OCTOBER: 'Outubro',
			NOVEMBER: 'Novembro',
			DECEMBER: 'Dezembro'
		},
		QuantityType: {
			GOOD: 'Bom',
			FEW: 'Pouco',
			NOTHING: 'Recusou',
			NA: 'Não informado'
		},
		QuantityMealsType: {
			REPEATED: 'Repetiu',
			GOOD: 'Bom',
			FEW: 'Pouco',
			NOTHING: 'Recusou',
			NA: 'Não informado'
		},
		Presence: {
			PRESENT: 'Presente',
			LATE: 'Atrasado',
			ABSENT: 'Ausente'
		},
		HumorTypes: {
			HAPPY: 'Feliz',
			NEUTRAL: 'Neutro',
			SLEEPY: 'Sonolento',
			SAD: 'Triste',
			TEARFUL: 'Choroso',
			ANGRY: 'Irritado'
		},
		MealTimeType: {
			BREAKFAST: 'Café da manhã',
			MORNING_SNACK: 'Lanche da manhã',
			LUNCH: 'Almoço',
			AFTERNOON_SNACK: 'Lanche da tarde',
			DINNER: 'Janta'
		},
		AgendaEvacuationType: {
			NORMAL: 'Normal',
			DIARRHEA: 'Diarréia',
			HARD: 'Duro',
			SOFT: 'Mole'
		},
		DayShiftType: {
			MATUTINAL: 'Manhã',
			VESPERTINE: 'Tarde',
			NIGHTLY: 'Noite',
			FULLTIME: 'Integral'
		},
		ParticipationType: {
			LITTLE: 'Pouco participativo',
			PARTICIPATED: 'Participativo',
			MUCH: 'Muito participativo'
		},
		SchoolClassLevelType: {
			'Bercario': 'Berçário',
			'Infantil': 'Infantil',
			'Fundamental_1': 'Fundamental 1',
			'Fundamental_2': 'Fundamental 2',
			'EnsinoMedio': 'Ensino Médio',
			// 'Universitario': 'Universitário'
		},
		StatusType: {
			NOT_CREATED: 'Não criado',
			CREATED: 'Criado',
			IN_APPROVAL: 'Em aprovação',
			IN_REVISION: 'Em revisão',
			PROCESSING: 'Processando',
			REPROCESS: '',
			APPROVED: 'Aprovado',
			SENT: 'Enviado',
			READED: 'Lido'
		},
		MessageStatusType: {
			READ: 'Visualizada por todos',
			NOT_READ: 'Não lida',
			PARTIAL_READ: 'Parcialmente visualizada',
		},
		RecipientsGroupType: {
			ALL_SCHOOL: 'Toda a escola',
			PER_LEVEL: 'Por nível de ensino',
			PER_GRADE: 'Por ano de ensino (série)',
			PER_CLASS: 'Por turma'
		},
		viewersGalleryType: {
			ALL: 'Toda a escola',
			SCHOOL_CLASS: 'Por turma',
			STUDENT: 'Por alunos',
		},
		StatusScheduledHomework: {
			ND: 'Não informado',
			COMPLETE: 'Sim',
			INCOMPLETE: 'Parcial',
			UNDELIVERED: 'Não'
		},
		Levels: {
			BERCARIO: 'Berçário',
			INFANTIL: 'Infantil',
			FUNDAMENTAL_1: 'Fundamental 1',
			FUNDAMENTAL_2: 'Fundamental 2',
			ENSINOMEDIO: 'Ensino médio',
			CURSOLIVRE: 'Curso livre'
		},
		Plans: {
			BASIC: 'Pro',
			PREMIUM: 'Business'
		},
		QuestionType: {
			MULTIPLE_INTELLIGENCES: 'Múltiplas Inteligências',
			SOCIOEMOTIONAL: 'Socioemocional',
			LEARNING_APTITUDE: 'Aptidão para aprendizagem'
		}
	},
	Settings: {
		Pagination: {
			layout: 'prev, next',
			pageSize: 25
		}
	}
};



// WEBPACK FOOTER //
// ./sources/store/state.js